module.exports = __webpack_public_path__ + "static/media/ai.becaf815.png";